import { INameValue } from "../components/interfaces/common";

export const accCategory = [
    { name: '전체', value: '00000' },
    { name: '원재료', value: '15300' },
    { name: '반제품', value: '16200' },
    { name: '제품', value: '15000' },
] as INameValue[]

export const annCategory = [
    { name: '사내', value: '1' },
    { name: '가맹점', value: '9' }
] as INameValue[]